import React from "react";
import "./Services.css";
import { useNavigate } from "react-router-dom";

const serviceData = [
  {
    title: "CCTV & Security Surveillance",
    description:
      "Vitri Enterprises offers reliable Fire Alarm Systems to ensure early hazard detection and safety for your space.",
    link: "/cctv-camera",
  },
  {
    title: "Video Door Phone",
    description:
      "Vitri Enterprises offers reliable video door phones, ensuring secure and convenient visitor management for your home or office.",
    link: "/video-door-phone",
  },
  {
    title: "Boom Barrier System",
    description:
      "Vitri Enterprises provides efficient Boom Barrier Systems, ensuring controlled access and enhanced security for entrances in commercial and residential areas.",
    link: "/boom-barrier-system",
  },
  {
    title: "EPABX",
    description:
      "Vitri Enterprises provides advanced EPABX systems, offering seamless communication solutions for businesses to enhance internal and external connectivity.",
    link: "/epabx",
  },
  {
    title: "Networking Solutions",
    description:
      "Vitri Enterprises delivers high-performance networking solutions, ensuring seamless connectivity and optimized performance for businesses and enterprises.",
    link: "/networking-solutions",
  },
  {
    title: "Access Control",
    description:
      "Vitri Enterprises offers cutting-edge access control systems, providing secure and efficient entry management for offices, industries, and residential buildings.",
    link: "/access-control",
  },
];

const Services = () => {
  const navigate = useNavigate();

  return (
    <section className="bleezy-service-area bleezy-promo-area section_t_100 section_b_70">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="heading_container" style={{ marginBottom: "30px" }}>
              <h2 className="section-title">Our Services</h2>
            </div>
          </div>
        </div>
        <div className="row">
          {serviceData.map((service, index) => (
            <div key={index} className="col-md-4 col-sm-4">
              <div className="single-service">
                <h3>
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    {service.title}
                  </a>
                </h3>
                <p>{service.description}</p>
                <div
                  className="btn-find-more"
                  onClick={() => navigate(service.link)}
                >
                  Read More
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
